var _regeneratorRuntime = require("/tmp/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("qs"), require("url-join"));else if ("function" == typeof define && define.amd) define(["qs", "url-join"], t);else {
    var n = "object" == typeof exports ? t(require("qs"), require("url-join")) : t(e.qs, e["url-join"]);

    for (var r in n) {
      ("object" == typeof exports ? exports : e)[r] = n[r];
    }
  }
}(window, function (e, t) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 5);
  }([function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.innerInitializeUserAuth = t.innerLogoutUser = t.innerLoginUser = t.setPreviousLocation = t.logoutUser = t.setLoginError = t.userLoginSuccess = t.loginUser = t.setAuthCheckError = t.authCheckComplete = t.authCheckStart = t.setSilentAuthCheck = t.initializeUserAuth = void 0;
    var r,
        o = n(6),
        i = (r = o) && r.__esModule ? r : {
      default: r
    },
        u = n(9),
        a = n(1),
        c = n(2),
        s = n(12),
        f = n(4),
        l = n(3);
    t.initializeUserAuth = (0, u.createAction)("AUTH_CHECK_INITIALIZE");

    var d = t.setSilentAuthCheck = (0, u.createAction)("AUTH_CHECK_SILENT"),
        h = t.authCheckStart = (0, u.createAction)("AUTH_CHECK_START"),
        v = t.authCheckComplete = (0, u.createAction)("AUTH_CHECK_COMPLETE"),
        p = (t.setAuthCheckError = (0, u.createAction)("AUTH_CHECK_ERROR"), t.loginUser = (0, u.createAction)("LOGIN_USER", {
      noPayload: !0
    }), t.userLoginSuccess = (0, u.createAction)("USER_LOGIN_SUCCESS")),
        y = t.setLoginError = (0, u.createAction)("LOGIN_SILENT_ERROR"),
        g = (t.logoutUser = (0, u.createAction)("LOGOUT_USER_INITIALIZE", {
      noPayload: !0
    }), t.setPreviousLocation = (0, u.createAction)("SET_PREVIOUS_LOCATION")),
        m = t.innerLoginUser = function (e, t) {
      return function (n, r) {
        return _(t)(n, r).then(function () {
          return n(h());
        }).then(function () {
          return (0, s.trySilentLogin)(e)(n, r);
        }).catch(function (t) {
          console.log(t);

          try {
            return (0, f.login)(e);
          } catch (t) {
            throw t;
          }
        }).then(function (t) {
          return t || (0, f.login)(e);
        }).then(function (o) {
          return b(e, o, t)(n, r);
        });
      };
    },
        b = function b(e, t, n) {
      return function (r, o) {
        if (t) return j(e, t, n)(r, o), r(p(t)), (0, f.getPreviousLocation)().then(function (e) {
          return r(g(e));
        }).then(function () {
          return n.emit("loginSuccess", r, o);
        }).catch(function (e) {
          return r(y("An error occurred after login, unable to restore state: " + e + ". You will be logged out.")), n.emit("loginError", r, o), _(n)(r, o);
        }).then(function () {
          return r(v()), t;
        });
      };
    },
        _ = (0, u.asyncAction)({
      baseName: "USER_LOGOUT",
      action: function action(e) {
        return function (t) {
          return function (n, r) {
            return n(e.start()), (0, f.logout)().then(function () {
              t.emit("logoutSuccess", n, r), n(e.success());
            }).catch(function (o) {
              t.emit("logoutError", n, r), n(e.error(o));
            });
          };
        };
      }
    });

    t.innerLogoutUser = _;

    t.innerInitializeUserAuth = function (e, t) {
      return function (n, r) {
        return (0, s.inIframe)() ? (0, s.iframeSilentLogin)() : (0, l.hasAuthCheckStarted)(r()) ? Promise.resolve() : (n(h()), S()(n, r).then(function () {
          return (0, f.getTokenFromRedirectOrStore)();
        }).catch(function (e) {
          n(y(e)), t.emit("loginError", n, r);
        }).then(function (o) {
          return o ? b(e, o, t)(n, r) : m(e, t)(n, r);
        }));
      };
    };

    var S = function S() {
      return function (e, t) {
        return c.hydrateStore.getItem(a.RECOVERY_KEY).catch(function (e) {
          throw console.log(e), e;
        }).then(function (n) {
          if (n && I(n)) return E()(e, t).then(function () {
            c.hydrateStore.removeItem(a.RECOVERY_KEY);
          }).catch(function (e) {
            console.error("error waiting for pending", e);
          });
        });
      };
    },
        I = function I(e) {
      var t = !1;
      return e.form && (t = Object.keys(e.form).some(function (t) {
        var n = e.form[t];
        return n.anyTouched && !(0, i.default)(n.initial, n.values);
      })), t;
    },
        E = function E() {
      return function (e, t) {
        return new Promise(function (e, n) {
          var r = new Date(Date.now() + 2e4),
              o = setInterval(function () {
            r.getTime() - Date.now() < 0 && (clearInterval(o), n(new Error("error recovering expired login"))), w(t()) || (clearInterval(o), e());
          }, 20);
        });
      };
    },
        w = function w(e) {
      return Object.keys(e.request).some(function (t) {
        return (e.request[t] || {}).isPending;
      });
    },
        O = function O(e, t) {
      return function (n, r) {
        var o = r();
        return (0, l.selectIsSilentAuthRunning)(o) || (0, l.selectLoginError)(o) ? Promise.resolve() : (n(d(!0)), (0, s.trySilentLogin)(e)(n, r).then(function (o) {
          o || (0, f.login)(e), n(p(o)), t.emit("refreshSuccess", n, r), j(e, o, t)(n, r);
        }).catch(function (e) {
          n(y(e)), t.emit("refreshError", n, r);
        }).finally(function () {
          return n(d(!1));
        }));
      };
    },
        k = null,
        j = function j(e, t, n) {
      return function (r, o) {
        k && clearInterval(k), k = setInterval(function () {
          if (!(0, l.selectIsSilentAuthRunning)(o()) && (0, l.selectIsLoggedIn)(o())) return !t.isExpired && t.shouldRefresh ? O(e, n)(r, o) : t.isExpired ? O(e, n)(r, o).catch(function (e) {
            return console.error("error refreshing login", e), c.hydrateStore.setItem(a.RECOVERY_KEY, o()).then(function () {
              r(y("Login Expired. You must log in again")), _(n)(r, o), clearInterval(k), k = null;
            });
          }) : void 0;
        }, 1e3);
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.LOCATION_KEY = "ngp-auth:location", t.TOKEN_KEY = "ngp-auth:token", t.RECOVERY_KEY = "ngp-auth:recover", t.SILENT_LOGIN_IFRAME_ID = "silent-login";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.hydrateStore = t.tokenStore = t.initStore = void 0, t.initTokenStore = c, t.initHydrateStore = s;
    var r,
        o = n(10),
        i = (r = o) && r.__esModule ? r : {
      default: r
    };
    var u = void 0,
        a = void 0;

    t.initStore = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.tokenName,
          n = e.hydrateName;
      u || c(t), a || s(n);
    };

    function c() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "tokens";
      t.tokenStore = u = i.default.createInstance({
        name: e
      });
    }

    function s() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "hydrate";
      t.hydrateStore = a = i.default.createInstance({
        name: e
      });
    }

    t.tokenStore = u, t.hydrateStore = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.hasAuthCheckFinished = t.hasAuthCheckStarted = t.selectPreviousLocation = t.selectIsLoggedIn = t.selectLogoutError = t.selectLoginError = t.selectIsSilentAuthRunning = t.selectTokenClaims = t.selectUserGroups = t.selectOpenIDToken = t.selectAccessToken = t.selectName = t.selectEmail = t.selectUsername = void 0;
    var r = n(0);
    var o = {
      hasAuthCheckStarted: !1,
      hasAuthCheckFinished: !1,
      isSilentLoginRunning: !1,
      isLoggingIn: !1,
      isLoggingOut: !1,
      isLoggedIn: !1,
      username: null,
      name: null,
      email: null,
      accessToken: null,
      openIdToken: null,
      scope: null,
      claims: null,
      groups: [],
      previousLocation: null,
      loginError: null,
      logoutError: null
    };

    t.default = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : o,
          t = arguments[1];

      switch (t.type) {
        case r.authCheckStart.type:
          return Object.assign({}, e, {
            hasAuthCheckStarted: !0,
            hasAuthCheckFinished: !1
          });

        case r.authCheckComplete.type:
          return Object.assign({}, e, {
            hasAuthCheckFinished: !0,
            previousLocation: null
          });

        case r.setSilentAuthCheck.type:
          return Object.assign({}, e, {
            isSilentLoginRunning: t.payload
          });

        case r.setLoginError.type:
          return Object.assign({}, e, {
            loginError: t.payload.toString(),
            isLoggedIn: !1
          });

        case r.userLoginSuccess.type:
          return Object.assign({}, e, {
            isLoggedIn: !0,
            username: t.payload.username.toLowerCase(),
            groups: t.payload.groups,
            claims: t.payload.claims,
            name: t.payload.name,
            accessToken: t.payload.accessToken,
            openIdToken: t.payload.openIdToken,
            email: t.payload.email,
            scope: t.payload.scope,
            loginError: null
          });

        case r.innerLogoutUser.event.success:
          return Object.assign({}, e, {
            username: null,
            name: null,
            isLoggedIn: !1,
            email: null,
            scope: null
          });

        case r.innerLogoutUser.event.error:
          return Object.assign({}, e, {
            logoutError: t.payload.toString()
          });

        case r.setPreviousLocation.type:
          return Object.assign({}, e, {
            previousLocation: t.payload
          });

        default:
          return e;
      }
    };

    t.selectUsername = function (e) {
      return e.auth.username;
    }, t.selectEmail = function (e) {
      return e.auth.email;
    }, t.selectName = function (e) {
      return e.auth.name;
    }, t.selectAccessToken = function (e) {
      return e.auth.accessToken;
    }, t.selectOpenIDToken = function (e) {
      return e.auth.openIdToken;
    }, t.selectUserGroups = function (e) {
      return [].concat(function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }

        return Array.from(e);
      }(e.auth.groups));
    }, t.selectTokenClaims = function (e) {
      return Object.assign({}, e.auth.claims);
    }, t.selectIsSilentAuthRunning = function (e) {
      return e.auth.isSilentLoginRunning;
    }, t.selectLoginError = function (e) {
      return e.auth.loginError;
    }, t.selectLogoutError = function (e) {
      return e.auth.logoutError;
    }, t.selectIsLoggedIn = function (e) {
      return e.auth.isLoggedIn;
    }, t.selectPreviousLocation = function (e) {
      return e.auth.previousLocation;
    }, t.hasAuthCheckStarted = function (e) {
      return e.auth.hasAuthCheckStarted;
    }, t.hasAuthCheckFinished = function (e) {
      return e.auth.hasAuthCheckFinished;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getPreviousLocation = t.login = t.makeToken = void 0, t.getTokenFromStore = f, t.hasPreviousLogin = function () {
      return i.tokenStore.getItem(u.TOKEN_KEY).then(function (e) {
        return !!e;
      });
    }, t.getTokenFromRedirectOrStore = function () {
      return f().then(function (e) {
        return e || l();
      });
    }, t.getTokenFromRedirect = l, t.getLoginUrl = v, t.logout = p;
    var r = a(n(13)),
        o = a(n(14)),
        i = n(2),
        u = n(1);

    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var c = {
      get isExpired() {
        return 1e3 * this.expiresAt < Date.now();
      },

      get shouldRefresh() {
        return 1e3 * this.expiresAt < Date.now() + 3e5;
      }

    },
        s = t.makeToken = function (e) {
      return Object.assign(Object.create(c), e);
    };

    function f() {
      return i.tokenStore.getItem(u.TOKEN_KEY).then(function (e) {
        return null == e ? null : s(e);
      }).then(function (e) {
        return d(e);
      });
    }

    function l() {
      return new Promise(function (e, t) {
        try {
          var n = function (e) {
            if (!e || !e.length) return null;
            "#" === e[0] && (e = e.substring(1));
            var t = r.default.parse(e);
            if (t.error) throw window.location.hash = "/", new Error("Error logging in: " + (t.error_description || "Unknown Error"));
            return t.access_token ? t : null;
          }(window.location.hash);

          if (!n) return e(null);
          window.location.hash = "/", n = s(function (e) {
            if (!e || !e.access_token) return null;
            var t = e.access_token.split("."),
                n = e.id_token.split("."),
                r = h(t[1]),
                o = h(n[1]);
            return {
              accessToken: e.access_token,
              openIdToken: e.id_token,
              expiresIn: e.expires_in,
              expiresAt: r.exp,
              username: r.sub,
              email: o.email,
              name: o.name,
              groups: r.groups || [],
              claims: r,
              scope: r.scp
            };
          }(n)), i.tokenStore.setItem(u.TOKEN_KEY, n).then(function () {
            return d(n);
          }).then(function () {
            return e(n);
          }).catch(function (e) {
            return t(e);
          });
        } catch (e) {
          t(e);
        }
      });
    }

    function d(e) {
      return e ? e.isExpired ? p().then(function () {}) : Promise.resolve(e) : Promise.resolve(null);
    }

    var h = function h(e) {
      return JSON.parse(window.atob(e));
    };

    t.login = function (e) {
      var t = {
        pathname: window.location.pathname,
        query: window.location.search ? r.default.parse(window.location.search.substring(1)) : null
      };
      return i.tokenStore.setItem(u.LOCATION_KEY, t).then(function () {
        window.location.assign(v({
          config: e
        }));
      });
    };

    function v() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.config,
          n = e.skipPrompt,
          i = e.state;
      return i = i || "1", (0, o.default)(t.authorization, "?" + r.default.stringify({
        response_type: "id_token token",
        client_id: t.client_id,
        scope: "profile openid email idpType",
        redirect_uri: t.redirect_uri,
        nonce: "1",
        state: i,
        prompt: n ? "none" : void 0
      }));
    }

    t.getPreviousLocation = function () {
      return i.tokenStore.getItem(u.LOCATION_KEY).then(function (e) {
        return e ? i.tokenStore.removeItem(u.LOCATION_KEY).then(function () {
          return e;
        }).catch(function (t) {
          return console.log("Error clearing token store: " + t.message), e;
        }) : null;
      });
    };

    function p() {
      return i.tokenStore.removeItem(u.TOKEN_KEY).catch(function (e) {
        console.error("Error clearing token store: " + e.message);
      });
    }
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(3);
    Object.defineProperty(t, "reducer", {
      enumerable: !0,
      get: function get() {
        return a(r).default;
      }
    }), Object.defineProperty(t, "hasAuthCheckFinished", {
      enumerable: !0,
      get: function get() {
        return r.hasAuthCheckFinished;
      }
    }), Object.defineProperty(t, "selectUsername", {
      enumerable: !0,
      get: function get() {
        return r.selectUsername;
      }
    }), Object.defineProperty(t, "selectName", {
      enumerable: !0,
      get: function get() {
        return r.selectName;
      }
    }), Object.defineProperty(t, "selectEmail", {
      enumerable: !0,
      get: function get() {
        return r.selectEmail;
      }
    }), Object.defineProperty(t, "selectIsLoggedIn", {
      enumerable: !0,
      get: function get() {
        return r.selectIsLoggedIn;
      }
    }), Object.defineProperty(t, "selectAccessToken", {
      enumerable: !0,
      get: function get() {
        return r.selectAccessToken;
      }
    }), Object.defineProperty(t, "selectOpenIDToken", {
      enumerable: !0,
      get: function get() {
        return r.selectOpenIDToken;
      }
    }), Object.defineProperty(t, "selectUserGroups", {
      enumerable: !0,
      get: function get() {
        return r.selectUserGroups;
      }
    }), Object.defineProperty(t, "selectTokenClaims", {
      enumerable: !0,
      get: function get() {
        return r.selectTokenClaims;
      }
    }), Object.defineProperty(t, "selectLoginError", {
      enumerable: !0,
      get: function get() {
        return r.selectLoginError;
      }
    }), Object.defineProperty(t, "selectLogoutError", {
      enumerable: !0,
      get: function get() {
        return r.selectLogoutError;
      }
    });
    var o = n(0);
    Object.defineProperty(t, "loginUser", {
      enumerable: !0,
      get: function get() {
        return o.loginUser;
      }
    }), Object.defineProperty(t, "logoutUser", {
      enumerable: !0,
      get: function get() {
        return o.logoutUser;
      }
    }), Object.defineProperty(t, "authCheckStart", {
      enumerable: !0,
      get: function get() {
        return o.authCheckStart;
      }
    }), Object.defineProperty(t, "userLoginSuccess", {
      enumerable: !0,
      get: function get() {
        return o.userLoginSuccess;
      }
    }), Object.defineProperty(t, "initializeUserAuth", {
      enumerable: !0,
      get: function get() {
        return o.initializeUserAuth;
      }
    });
    var i = n(15);
    Object.defineProperty(t, "createAuthMiddleware", {
      enumerable: !0,
      get: function get() {
        return a(i).default;
      }
    });
    var u = n(16);

    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "AuthEvents", {
      enumerable: !0,
      get: function get() {
        return a(u).default;
      }
    });
  }, function (e, t, n) {
    var r = Array.prototype.slice,
        o = n(7),
        i = n(8),
        u = e.exports = function (e, t, n) {
      return n || (n = {}), e === t || (e instanceof Date && t instanceof Date ? e.getTime() === t.getTime() : !e || !t || "object" != typeof e && "object" != typeof t ? n.strict ? e === t : e == t : function (e, t, n) {
        var s, f;
        if (a(e) || a(t)) return !1;
        if (e.prototype !== t.prototype) return !1;
        if (i(e)) return !!i(t) && (e = r.call(e), t = r.call(t), u(e, t, n));

        if (c(e)) {
          if (!c(t)) return !1;
          if (e.length !== t.length) return !1;

          for (s = 0; s < e.length; s++) {
            if (e[s] !== t[s]) return !1;
          }

          return !0;
        }

        try {
          var l = o(e),
              d = o(t);
        } catch (e) {
          return !1;
        }

        if (l.length != d.length) return !1;

        for (l.sort(), d.sort(), s = l.length - 1; s >= 0; s--) {
          if (l[s] != d[s]) return !1;
        }

        for (s = l.length - 1; s >= 0; s--) {
          if (f = l[s], !u(e[f], t[f], n)) return !1;
        }

        return typeof e == typeof t;
      }(e, t, n));
    };

    function a(e) {
      return null == e;
    }

    function c(e) {
      return !(!e || "object" != typeof e || "number" != typeof e.length) && "function" == typeof e.copy && "function" == typeof e.slice && !(e.length > 0 && "number" != typeof e[0]);
    }
  }, function (e, t) {
    function n(e) {
      var t = [];

      for (var n in e) {
        t.push(n);
      }

      return t;
    }

    (e.exports = "function" == typeof Object.keys ? Object.keys : n).shim = n;
  }, function (e, t) {
    var n = "[object Arguments]" == function () {
      return Object.prototype.toString.call(arguments);
    }();

    function r(e) {
      return "[object Arguments]" == Object.prototype.toString.call(e);
    }

    function o(e) {
      return e && "object" == typeof e && "number" == typeof e.length && Object.prototype.hasOwnProperty.call(e, "callee") && !Object.prototype.propertyIsEnumerable.call(e, "callee") || !1;
    }

    (t = e.exports = n ? r : o).supported = r, t.unsupported = o;
  }, function (e, t) {
    !function (e, t) {
      for (var n in t) {
        e[n] = t[n];
      }
    }(t, function (e) {
      var t = {};

      function n(r) {
        if (t[r]) return t[r].exports;
        var o = t[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var o in e) {
          n.d(r, o, function (t) {
            return e[t];
          }.bind(null, o));
        }
        return r;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 0);
    }([function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = function r(e) {
        return e;
      };

      t.createAction = function (e, t, n) {
        var o = "function" == typeof t ? t : t && t.noPayload ? null : r,
            i = function i() {
          var t = (arguments.length <= 0 ? void 0 : arguments[0]) instanceof Error,
              r = {
            type: e
          },
              i = null;
          return null !== o && (i = t ? arguments.length <= 0 ? void 0 : arguments[0] : o.apply(void 0, arguments)), null != i && (r.payload = i), (t || i instanceof Error) && (r.error = !0), "function" == typeof n && (r.meta = n.apply(void 0, arguments)), r;
        };

        return i.toString = function () {
          return e.toString();
        }, i.type = e.toString(), i;
      }, t.action = function (e, t) {
        return {
          type: e,
          payload: t
        };
      }, t.asyncAction = function (e) {
        var t = {
          name: e.baseName,
          start: e.baseName + "_START",
          success: e.baseName + "_SUCCESS",
          error: e.baseName + "_ERROR"
        },
            n = function n(t, _n, r) {
          return function (o) {
            return {
              type: t,
              payload: o,
              request: {
                id: e.baseName,
                isPending: _n,
                error: r ? o : null
              }
            };
          };
        },
            r = {
          start: n(t.start, !0),
          success: n(t.success, !1),
          error: n(t.error, !1, !0)
        },
            o = e.action(r);

        return o.event = t, o;
      }, t.pollingAction = function (e, t) {
        var n = null,
            r = function r() {
          n && clearInterval(n);
        };

        return {
          start: function start(o, i) {
            r(), e(o, i), n = setInterval(function () {
              return e(o, i);
            }, t);
          },
          stop: r
        };
      }, t.parseErrorMiddleware = function (e) {
        return function (e) {
          return function (t) {
            return t.type && t.payload instanceof Error && (t = Object.assign({}, t, {
              payload: t.payload.message
            })), e(t);
          };
        };
      };
    }]));
  }, function (e, t, n) {
    (function (t) {
      var n;

      e.exports = function e(t, r, o) {
        function i(a, c) {
          if (!r[a]) {
            if (!t[a]) {
              var s = "function" == typeof n && n;
              if (!c && s) return n(a, !0);
              if (u) return u(a, !0);
              var f = new Error("Cannot find module '" + a + "'");
              throw f.code = "MODULE_NOT_FOUND", f;
            }

            var l = r[a] = {
              exports: {}
            };
            t[a][0].call(l.exports, function (e) {
              var n = t[a][1][e];
              return i(n || e);
            }, l, l.exports, e, t, r, o);
          }

          return r[a].exports;
        }

        for (var u = "function" == typeof n && n, a = 0; a < o.length; a++) {
          i(o[a]);
        }

        return i;
      }({
        1: [function (e, n, r) {
          (function (e) {
            "use strict";

            var t,
                r,
                o = e.MutationObserver || e.WebKitMutationObserver;

            if (o) {
              var i = 0,
                  u = new o(f),
                  a = e.document.createTextNode("");
              u.observe(a, {
                characterData: !0
              }), t = function t() {
                a.data = i = ++i % 2;
              };
            } else if (e.setImmediate || void 0 === e.MessageChannel) t = "document" in e && "onreadystatechange" in e.document.createElement("script") ? function () {
              var t = e.document.createElement("script");
              t.onreadystatechange = function () {
                f(), t.onreadystatechange = null, t.parentNode.removeChild(t), t = null;
              }, e.document.documentElement.appendChild(t);
            } : function () {
              setTimeout(f, 0);
            };else {
              var c = new e.MessageChannel();
              c.port1.onmessage = f, t = function t() {
                c.port2.postMessage(0);
              };
            }

            var s = [];

            function f() {
              var e, t;
              r = !0;

              for (var n = s.length; n;) {
                for (t = s, s = [], e = -1; ++e < n;) {
                  t[e]();
                }

                n = s.length;
              }

              r = !1;
            }

            n.exports = function (e) {
              1 !== s.push(e) || r || t();
            };
          }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {}],
        2: [function (e, t, n) {
          "use strict";

          var r = e(1);

          function o() {}

          var i = {},
              u = ["REJECTED"],
              a = ["FULFILLED"],
              c = ["PENDING"];

          function s(e) {
            if ("function" != typeof e) throw new TypeError("resolver must be a function");
            this.state = c, this.queue = [], this.outcome = void 0, e !== o && h(this, e);
          }

          function f(e, t, n) {
            this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof n && (this.onRejected = n, this.callRejected = this.otherCallRejected);
          }

          function l(e, t, n) {
            r(function () {
              var r;

              try {
                r = t(n);
              } catch (t) {
                return i.reject(e, t);
              }

              r === e ? i.reject(e, new TypeError("Cannot resolve promise with itself")) : i.resolve(e, r);
            });
          }

          function d(e) {
            var t = e && e.then;
            if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function () {
              t.apply(e, arguments);
            };
          }

          function h(e, t) {
            var n = !1;

            function r(t) {
              n || (n = !0, i.reject(e, t));
            }

            function o(t) {
              n || (n = !0, i.resolve(e, t));
            }

            var u = v(function () {
              t(o, r);
            });
            "error" === u.status && r(u.value);
          }

          function v(e, t) {
            var n = {};

            try {
              n.value = e(t), n.status = "success";
            } catch (e) {
              n.status = "error", n.value = e;
            }

            return n;
          }

          t.exports = s, s.prototype.catch = function (e) {
            return this.then(null, e);
          }, s.prototype.then = function (e, t) {
            if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === u) return this;
            var n = new this.constructor(o);

            if (this.state !== c) {
              var r = this.state === a ? e : t;
              l(n, r, this.outcome);
            } else this.queue.push(new f(n, e, t));

            return n;
          }, f.prototype.callFulfilled = function (e) {
            i.resolve(this.promise, e);
          }, f.prototype.otherCallFulfilled = function (e) {
            l(this.promise, this.onFulfilled, e);
          }, f.prototype.callRejected = function (e) {
            i.reject(this.promise, e);
          }, f.prototype.otherCallRejected = function (e) {
            l(this.promise, this.onRejected, e);
          }, i.resolve = function (e, t) {
            var n = v(d, t);
            if ("error" === n.status) return i.reject(e, n.value);
            var r = n.value;
            if (r) h(e, r);else {
              e.state = a, e.outcome = t;

              for (var o = -1, u = e.queue.length; ++o < u;) {
                e.queue[o].callFulfilled(t);
              }
            }
            return e;
          }, i.reject = function (e, t) {
            e.state = u, e.outcome = t;

            for (var n = -1, r = e.queue.length; ++n < r;) {
              e.queue[n].callRejected(t);
            }

            return e;
          }, s.resolve = function (e) {
            return e instanceof this ? e : i.resolve(new this(o), e);
          }, s.reject = function (e) {
            var t = new this(o);
            return i.reject(t, e);
          }, s.all = function (e) {
            var t = this;
            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
            var n = e.length,
                r = !1;
            if (!n) return this.resolve([]);

            for (var u = new Array(n), a = 0, c = -1, s = new this(o); ++c < n;) {
              f(e[c], c);
            }

            return s;

            function f(e, o) {
              t.resolve(e).then(function (e) {
                u[o] = e, ++a !== n || r || (r = !0, i.resolve(s, u));
              }, function (e) {
                r || (r = !0, i.reject(s, e));
              });
            }
          }, s.race = function (e) {
            var t = this;
            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
            var n = e.length,
                r = !1;
            if (!n) return this.resolve([]);

            for (var u, a = -1, c = new this(o); ++a < n;) {
              u = e[a], t.resolve(u).then(function (e) {
                r || (r = !0, i.resolve(c, e));
              }, function (e) {
                r || (r = !0, i.reject(c, e));
              });
            }

            return c;
          };
        }, {
          1: 1
        }],
        3: [function (e, n, r) {
          (function (t) {
            "use strict";

            "function" != typeof t.Promise && (t.Promise = e(2));
          }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
        }, {
          2: 2
        }],
        4: [function (e, t, n) {
          "use strict";

          var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
              o = function () {
            try {
              if ("undefined" != typeof indexedDB) return indexedDB;
              if ("undefined" != typeof webkitIndexedDB) return webkitIndexedDB;
              if ("undefined" != typeof mozIndexedDB) return mozIndexedDB;
              if ("undefined" != typeof OIndexedDB) return OIndexedDB;
              if ("undefined" != typeof msIndexedDB) return msIndexedDB;
            } catch (e) {
              return;
            }
          }();

          function i(e, t) {
            e = e || [], t = t || {};

            try {
              return new Blob(e, t);
            } catch (i) {
              if ("TypeError" !== i.name) throw i;

              for (var n = "undefined" != typeof BlobBuilder ? BlobBuilder : "undefined" != typeof MSBlobBuilder ? MSBlobBuilder : "undefined" != typeof MozBlobBuilder ? MozBlobBuilder : WebKitBlobBuilder, r = new n(), o = 0; o < e.length; o += 1) {
                r.append(e[o]);
              }

              return r.getBlob(t.type);
            }
          }

          "undefined" == typeof Promise && e(3);
          var u = Promise;

          function a(e, t) {
            t && e.then(function (e) {
              t(null, e);
            }, function (e) {
              t(e);
            });
          }

          function c(e, t, n) {
            "function" == typeof t && e.then(t), "function" == typeof n && e.catch(n);
          }

          function s(e) {
            return "string" != typeof e && (console.warn(e + " used as a key, but it is not a string."), e = String(e)), e;
          }

          function f() {
            if (arguments.length && "function" == typeof arguments[arguments.length - 1]) return arguments[arguments.length - 1];
          }

          var l = "local-forage-detect-blob-support",
              d = void 0,
              h = {},
              v = Object.prototype.toString,
              p = "readonly",
              y = "readwrite";

          function g(e) {
            return "boolean" == typeof d ? u.resolve(d) : function (e) {
              return new u(function (t) {
                var n = e.transaction(l, y),
                    r = i([""]);
                n.objectStore(l).put(r, "key"), n.onabort = function (e) {
                  e.preventDefault(), e.stopPropagation(), t(!1);
                }, n.oncomplete = function () {
                  var e = navigator.userAgent.match(/Chrome\/(\d+)/),
                      n = navigator.userAgent.match(/Edge\//);
                  t(n || !e || parseInt(e[1], 10) >= 43);
                };
              }).catch(function () {
                return !1;
              });
            }(e).then(function (e) {
              return d = e;
            });
          }

          function m(e) {
            var t = h[e.name],
                n = {};
            n.promise = new u(function (e, t) {
              n.resolve = e, n.reject = t;
            }), t.deferredOperations.push(n), t.dbReady ? t.dbReady = t.dbReady.then(function () {
              return n.promise;
            }) : t.dbReady = n.promise;
          }

          function b(e) {
            var t = h[e.name],
                n = t.deferredOperations.pop();
            if (n) return n.resolve(), n.promise;
          }

          function _(e, t) {
            var n = h[e.name],
                r = n.deferredOperations.pop();
            if (r) return r.reject(t), r.promise;
          }

          function S(e, t) {
            return new u(function (n, r) {
              if (h[e.name] = h[e.name] || {
                forages: [],
                db: null,
                dbReady: null,
                deferredOperations: []
              }, e.db) {
                if (!t) return n(e.db);
                m(e), e.db.close();
              }

              var i = [e.name];
              t && i.push(e.version);
              var u = o.open.apply(o, i);
              t && (u.onupgradeneeded = function (t) {
                var n = u.result;

                try {
                  n.createObjectStore(e.storeName), t.oldVersion <= 1 && n.createObjectStore(l);
                } catch (n) {
                  if ("ConstraintError" !== n.name) throw n;
                  console.warn('The database "' + e.name + '" has been upgraded from version ' + t.oldVersion + " to version " + t.newVersion + ', but the storage "' + e.storeName + '" already exists.');
                }
              }), u.onerror = function (e) {
                e.preventDefault(), r(u.error);
              }, u.onsuccess = function () {
                n(u.result), b(e);
              };
            });
          }

          function I(e) {
            return S(e, !1);
          }

          function E(e) {
            return S(e, !0);
          }

          function w(e, t) {
            if (!e.db) return !0;
            var n = !e.db.objectStoreNames.contains(e.storeName),
                r = e.version < e.db.version,
                o = e.version > e.db.version;

            if (r && (e.version !== t && console.warn('The database "' + e.name + "\" can't be downgraded from version " + e.db.version + " to version " + e.version + "."), e.version = e.db.version), o || n) {
              if (n) {
                var i = e.db.version + 1;
                i > e.version && (e.version = i);
              }

              return !0;
            }

            return !1;
          }

          function O(e) {
            var t = function (e) {
              for (var t = e.length, n = new ArrayBuffer(t), r = new Uint8Array(n), o = 0; o < t; o++) {
                r[o] = e.charCodeAt(o);
              }

              return n;
            }(atob(e.data));

            return i([t], {
              type: e.type
            });
          }

          function k(e) {
            return e && e.__local_forage_encoded_blob;
          }

          function j(e) {
            var t = this,
                n = t._initReady().then(function () {
              var e = h[t._dbInfo.name];
              if (e && e.dbReady) return e.dbReady;
            });

            return c(n, e, e), n;
          }

          function A(e, t, n, r) {
            void 0 === r && (r = 1);

            try {
              var o = e.db.transaction(e.storeName, t);
              n(null, o);
            } catch (o) {
              if (r > 0 && (!e.db || "InvalidStateError" === o.name || "NotFoundError" === o.name)) return u.resolve().then(function () {
                if (!e.db || "NotFoundError" === o.name && !e.db.objectStoreNames.contains(e.storeName) && e.version <= e.db.version) return e.db && (e.version = e.db.version + 1), E(e);
              }).then(function () {
                return function (e) {
                  m(e);

                  for (var t = h[e.name], n = t.forages, r = 0; r < n.length; r++) {
                    var o = n[r];
                    o._dbInfo.db && (o._dbInfo.db.close(), o._dbInfo.db = null);
                  }

                  return e.db = null, I(e).then(function (t) {
                    return e.db = t, w(e) ? E(e) : t;
                  }).then(function (r) {
                    e.db = t.db = r;

                    for (var o = 0; o < n.length; o++) {
                      n[o]._dbInfo.db = r;
                    }
                  }).catch(function (t) {
                    throw _(e, t), t;
                  });
                }(e).then(function () {
                  A(e, t, n, r - 1);
                });
              }).catch(n);
              n(o);
            }
          }

          var N = {
            _driver: "asyncStorage",
            _initStorage: function _initStorage(e) {
              var t = this,
                  n = {
                db: null
              };
              if (e) for (var r in e) {
                n[r] = e[r];
              }
              var o = h[n.name];
              o || (o = {
                forages: [],
                db: null,
                dbReady: null,
                deferredOperations: []
              }, h[n.name] = o), o.forages.push(t), t._initReady || (t._initReady = t.ready, t.ready = j);
              var i = [];

              function a() {
                return u.resolve();
              }

              for (var c = 0; c < o.forages.length; c++) {
                var s = o.forages[c];
                s !== t && i.push(s._initReady().catch(a));
              }

              var f = o.forages.slice(0);
              return u.all(i).then(function () {
                return n.db = o.db, I(n);
              }).then(function (e) {
                return n.db = e, w(n, t._defaultConfig.version) ? E(n) : e;
              }).then(function (e) {
                n.db = o.db = e, t._dbInfo = n;

                for (var r = 0; r < f.length; r++) {
                  var i = f[r];
                  i !== t && (i._dbInfo.db = n.db, i._dbInfo.version = n.version);
                }
              });
            },
            _support: function () {
              try {
                if (!o) return !1;
                var e = "undefined" != typeof openDatabase && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform),
                    t = "function" == typeof fetch && -1 !== fetch.toString().indexOf("[native code");
                return (!e || t) && "undefined" != typeof indexedDB && "undefined" != typeof IDBKeyRange;
              } catch (e) {
                return !1;
              }
            }(),
            iterate: function iterate(e, t) {
              var n = this,
                  r = new u(function (t, r) {
                n.ready().then(function () {
                  A(n._dbInfo, p, function (o, i) {
                    if (o) return r(o);

                    try {
                      var u = i.objectStore(n._dbInfo.storeName),
                          a = u.openCursor(),
                          c = 1;
                      a.onsuccess = function () {
                        var n = a.result;

                        if (n) {
                          var r = n.value;
                          k(r) && (r = O(r));
                          var o = e(r, n.key, c++);
                          void 0 !== o ? t(o) : n.continue();
                        } else t();
                      }, a.onerror = function () {
                        r(a.error);
                      };
                    } catch (e) {
                      r(e);
                    }
                  });
                }).catch(r);
              });
              return a(r, t), r;
            },
            getItem: function getItem(e, t) {
              var n = this;
              e = s(e);
              var r = new u(function (t, r) {
                n.ready().then(function () {
                  A(n._dbInfo, p, function (o, i) {
                    if (o) return r(o);

                    try {
                      var u = i.objectStore(n._dbInfo.storeName),
                          a = u.get(e);
                      a.onsuccess = function () {
                        var e = a.result;
                        void 0 === e && (e = null), k(e) && (e = O(e)), t(e);
                      }, a.onerror = function () {
                        r(a.error);
                      };
                    } catch (e) {
                      r(e);
                    }
                  });
                }).catch(r);
              });
              return a(r, t), r;
            },
            setItem: function setItem(e, t, n) {
              var r = this;
              e = s(e);
              var o = new u(function (n, o) {
                var i;
                r.ready().then(function () {
                  return i = r._dbInfo, "[object Blob]" === v.call(t) ? g(i.db).then(function (e) {
                    return e ? t : (n = t, new u(function (e, t) {
                      var r = new FileReader();
                      r.onerror = t, r.onloadend = function (t) {
                        var r = btoa(t.target.result || "");
                        e({
                          __local_forage_encoded_blob: !0,
                          data: r,
                          type: n.type
                        });
                      }, r.readAsBinaryString(n);
                    }));
                    var n;
                  }) : t;
                }).then(function (t) {
                  A(r._dbInfo, y, function (i, u) {
                    if (i) return o(i);

                    try {
                      var a = u.objectStore(r._dbInfo.storeName);
                      null === t && (t = void 0);
                      var c = a.put(t, e);
                      u.oncomplete = function () {
                        void 0 === t && (t = null), n(t);
                      }, u.onabort = u.onerror = function () {
                        var e = c.error ? c.error : c.transaction.error;
                        o(e);
                      };
                    } catch (e) {
                      o(e);
                    }
                  });
                }).catch(o);
              });
              return a(o, n), o;
            },
            removeItem: function removeItem(e, t) {
              var n = this;
              e = s(e);
              var r = new u(function (t, r) {
                n.ready().then(function () {
                  A(n._dbInfo, y, function (o, i) {
                    if (o) return r(o);

                    try {
                      var u = i.objectStore(n._dbInfo.storeName),
                          a = u.delete(e);
                      i.oncomplete = function () {
                        t();
                      }, i.onerror = function () {
                        r(a.error);
                      }, i.onabort = function () {
                        var e = a.error ? a.error : a.transaction.error;
                        r(e);
                      };
                    } catch (e) {
                      r(e);
                    }
                  });
                }).catch(r);
              });
              return a(r, t), r;
            },
            clear: function clear(e) {
              var t = this,
                  n = new u(function (e, n) {
                t.ready().then(function () {
                  A(t._dbInfo, y, function (r, o) {
                    if (r) return n(r);

                    try {
                      var i = o.objectStore(t._dbInfo.storeName),
                          u = i.clear();
                      o.oncomplete = function () {
                        e();
                      }, o.onabort = o.onerror = function () {
                        var e = u.error ? u.error : u.transaction.error;
                        n(e);
                      };
                    } catch (e) {
                      n(e);
                    }
                  });
                }).catch(n);
              });
              return a(n, e), n;
            },
            length: function length(e) {
              var t = this,
                  n = new u(function (e, n) {
                t.ready().then(function () {
                  A(t._dbInfo, p, function (r, o) {
                    if (r) return n(r);

                    try {
                      var i = o.objectStore(t._dbInfo.storeName),
                          u = i.count();
                      u.onsuccess = function () {
                        e(u.result);
                      }, u.onerror = function () {
                        n(u.error);
                      };
                    } catch (e) {
                      n(e);
                    }
                  });
                }).catch(n);
              });
              return a(n, e), n;
            },
            key: function key(e, t) {
              var n = this,
                  r = new u(function (t, r) {
                e < 0 ? t(null) : n.ready().then(function () {
                  A(n._dbInfo, p, function (o, i) {
                    if (o) return r(o);

                    try {
                      var u = i.objectStore(n._dbInfo.storeName),
                          a = !1,
                          c = u.openCursor();
                      c.onsuccess = function () {
                        var n = c.result;
                        n ? 0 === e ? t(n.key) : a ? t(n.key) : (a = !0, n.advance(e)) : t(null);
                      }, c.onerror = function () {
                        r(c.error);
                      };
                    } catch (e) {
                      r(e);
                    }
                  });
                }).catch(r);
              });
              return a(r, t), r;
            },
            keys: function keys(e) {
              var t = this,
                  n = new u(function (e, n) {
                t.ready().then(function () {
                  A(t._dbInfo, p, function (r, o) {
                    if (r) return n(r);

                    try {
                      var i = o.objectStore(t._dbInfo.storeName),
                          u = i.openCursor(),
                          a = [];
                      u.onsuccess = function () {
                        var t = u.result;
                        t ? (a.push(t.key), t.continue()) : e(a);
                      }, u.onerror = function () {
                        n(u.error);
                      };
                    } catch (e) {
                      n(e);
                    }
                  });
                }).catch(n);
              });
              return a(n, e), n;
            },
            dropInstance: function dropInstance(e, t) {
              t = f.apply(this, arguments);
              var n,
                  r = this.config();

              if ((e = "function" != typeof e && e || {}).name || (e.name = e.name || r.name, e.storeName = e.storeName || r.storeName), e.name) {
                var i = e.name === r.name && this._dbInfo.db,
                    c = i ? u.resolve(this._dbInfo.db) : I(e).then(function (t) {
                  var n = h[e.name],
                      r = n.forages;
                  n.db = t;

                  for (var o = 0; o < r.length; o++) {
                    r[o]._dbInfo.db = t;
                  }

                  return t;
                });
                n = e.storeName ? c.then(function (t) {
                  if (t.objectStoreNames.contains(e.storeName)) {
                    var n = t.version + 1;
                    m(e);
                    var r = h[e.name],
                        i = r.forages;
                    t.close();

                    for (var a = 0; a < i.length; a++) {
                      var c = i[a];
                      c._dbInfo.db = null, c._dbInfo.version = n;
                    }

                    var s = new u(function (t, r) {
                      var i = o.open(e.name, n);
                      i.onerror = function (e) {
                        var t = i.result;
                        t.close(), r(e);
                      }, i.onupgradeneeded = function () {
                        var t = i.result;
                        t.deleteObjectStore(e.storeName);
                      }, i.onsuccess = function () {
                        var e = i.result;
                        e.close(), t(e);
                      };
                    });
                    return s.then(function (e) {
                      r.db = e;

                      for (var t = 0; t < i.length; t++) {
                        var n = i[t];
                        n._dbInfo.db = e, b(n._dbInfo);
                      }
                    }).catch(function (t) {
                      throw (_(e, t) || u.resolve()).catch(function () {}), t;
                    });
                  }
                }) : c.then(function (t) {
                  m(e);
                  var n = h[e.name],
                      r = n.forages;
                  t.close();

                  for (var i = 0; i < r.length; i++) {
                    var a = r[i];
                    a._dbInfo.db = null;
                  }

                  var c = new u(function (t, n) {
                    var r = o.deleteDatabase(e.name);
                    r.onerror = r.onblocked = function (e) {
                      var t = r.result;
                      t && t.close(), n(e);
                    }, r.onsuccess = function () {
                      var e = r.result;
                      e && e.close(), t(e);
                    };
                  });
                  return c.then(function (e) {
                    n.db = e;

                    for (var t = 0; t < r.length; t++) {
                      var o = r[t];
                      b(o._dbInfo);
                    }
                  }).catch(function (t) {
                    throw (_(e, t) || u.resolve()).catch(function () {}), t;
                  });
                });
              } else n = u.reject("Invalid arguments");

              return a(n, t), n;
            }
          },
              L = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
              T = "~~local_forage_type~",
              C = /^~~local_forage_type~([^~]+)~/,
              R = "__lfsc__:",
              P = R.length,
              x = "arbf",
              U = "blob",
              D = "si08",
              M = "ui08",
              F = "uic8",
              B = "si16",
              z = "si32",
              K = "ur16",
              q = "ui32",
              Y = "fl32",
              G = "fl64",
              H = P + x.length,
              W = Object.prototype.toString;

          function V(e) {
            var t,
                n,
                r,
                o,
                i,
                u = .75 * e.length,
                a = e.length,
                c = 0;
            "=" === e[e.length - 1] && (u--, "=" === e[e.length - 2] && u--);
            var s = new ArrayBuffer(u),
                f = new Uint8Array(s);

            for (t = 0; t < a; t += 4) {
              n = L.indexOf(e[t]), r = L.indexOf(e[t + 1]), o = L.indexOf(e[t + 2]), i = L.indexOf(e[t + 3]), f[c++] = n << 2 | r >> 4, f[c++] = (15 & r) << 4 | o >> 2, f[c++] = (3 & o) << 6 | 63 & i;
            }

            return s;
          }

          function J(e) {
            var t,
                n = new Uint8Array(e),
                r = "";

            for (t = 0; t < n.length; t += 3) {
              r += L[n[t] >> 2], r += L[(3 & n[t]) << 4 | n[t + 1] >> 4], r += L[(15 & n[t + 1]) << 2 | n[t + 2] >> 6], r += L[63 & n[t + 2]];
            }

            return n.length % 3 == 2 ? r = r.substring(0, r.length - 1) + "=" : n.length % 3 == 1 && (r = r.substring(0, r.length - 2) + "=="), r;
          }

          var Q = {
            serialize: function serialize(e, t) {
              var n = "";

              if (e && (n = W.call(e)), e && ("[object ArrayBuffer]" === n || e.buffer && "[object ArrayBuffer]" === W.call(e.buffer))) {
                var r,
                    o = R;
                e instanceof ArrayBuffer ? (r = e, o += x) : (r = e.buffer, "[object Int8Array]" === n ? o += D : "[object Uint8Array]" === n ? o += M : "[object Uint8ClampedArray]" === n ? o += F : "[object Int16Array]" === n ? o += B : "[object Uint16Array]" === n ? o += K : "[object Int32Array]" === n ? o += z : "[object Uint32Array]" === n ? o += q : "[object Float32Array]" === n ? o += Y : "[object Float64Array]" === n ? o += G : t(new Error("Failed to get type for BinaryArray"))), t(o + J(r));
              } else if ("[object Blob]" === n) {
                var i = new FileReader();
                i.onload = function () {
                  var n = T + e.type + "~" + J(this.result);
                  t(R + U + n);
                }, i.readAsArrayBuffer(e);
              } else try {
                t(JSON.stringify(e));
              } catch (n) {
                console.error("Couldn't convert value into a JSON string: ", e), t(null, n);
              }
            },
            deserialize: function deserialize(e) {
              if (e.substring(0, P) !== R) return JSON.parse(e);
              var t,
                  n = e.substring(H),
                  r = e.substring(P, H);

              if (r === U && C.test(n)) {
                var o = n.match(C);
                t = o[1], n = n.substring(o[0].length);
              }

              var u = V(n);

              switch (r) {
                case x:
                  return u;

                case U:
                  return i([u], {
                    type: t
                  });

                case D:
                  return new Int8Array(u);

                case M:
                  return new Uint8Array(u);

                case F:
                  return new Uint8ClampedArray(u);

                case B:
                  return new Int16Array(u);

                case K:
                  return new Uint16Array(u);

                case z:
                  return new Int32Array(u);

                case q:
                  return new Uint32Array(u);

                case Y:
                  return new Float32Array(u);

                case G:
                  return new Float64Array(u);

                default:
                  throw new Error("Unkown type: " + r);
              }
            },
            stringToBuffer: V,
            bufferToString: J
          };

          function X(e, t, n, r) {
            e.executeSql("CREATE TABLE IF NOT EXISTS " + t.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], n, r);
          }

          function Z(e, t, n, r, o, i) {
            e.executeSql(n, r, o, function (e, u) {
              u.code === u.SYNTAX_ERR ? e.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [t.storeName], function (e, a) {
                a.rows.length ? i(e, u) : X(e, t, function () {
                  e.executeSql(n, r, o, i);
                }, i);
              }, i) : i(e, u);
            }, i);
          }

          var $ = {
            _driver: "webSQLStorage",
            _initStorage: function _initStorage(e) {
              var t = this,
                  n = {
                db: null
              };
              if (e) for (var r in e) {
                n[r] = "string" != typeof e[r] ? e[r].toString() : e[r];
              }
              var o = new u(function (e, r) {
                try {
                  n.db = openDatabase(n.name, String(n.version), n.description, n.size);
                } catch (e) {
                  return r(e);
                }

                n.db.transaction(function (o) {
                  X(o, n, function () {
                    t._dbInfo = n, e();
                  }, function (e, t) {
                    r(t);
                  });
                }, r);
              });
              return n.serializer = Q, o;
            },
            _support: "function" == typeof openDatabase,
            iterate: function iterate(e, t) {
              var n = this,
                  r = new u(function (t, r) {
                n.ready().then(function () {
                  var o = n._dbInfo;
                  o.db.transaction(function (n) {
                    Z(n, o, "SELECT * FROM " + o.storeName, [], function (n, r) {
                      for (var i = r.rows, u = i.length, a = 0; a < u; a++) {
                        var c = i.item(a),
                            s = c.value;
                        if (s && (s = o.serializer.deserialize(s)), void 0 !== (s = e(s, c.key, a + 1))) return void t(s);
                      }

                      t();
                    }, function (e, t) {
                      r(t);
                    });
                  });
                }).catch(r);
              });
              return a(r, t), r;
            },
            getItem: function getItem(e, t) {
              var n = this;
              e = s(e);
              var r = new u(function (t, r) {
                n.ready().then(function () {
                  var o = n._dbInfo;
                  o.db.transaction(function (n) {
                    Z(n, o, "SELECT * FROM " + o.storeName + " WHERE key = ? LIMIT 1", [e], function (e, n) {
                      var r = n.rows.length ? n.rows.item(0).value : null;
                      r && (r = o.serializer.deserialize(r)), t(r);
                    }, function (e, t) {
                      r(t);
                    });
                  });
                }).catch(r);
              });
              return a(r, t), r;
            },
            setItem: function setItem(e, t, n) {
              return function e(t, n, r, o) {
                var i = this;
                t = s(t);
                var c = new u(function (u, a) {
                  i.ready().then(function () {
                    void 0 === n && (n = null);
                    var c = n,
                        s = i._dbInfo;
                    s.serializer.serialize(n, function (n, f) {
                      f ? a(f) : s.db.transaction(function (e) {
                        Z(e, s, "INSERT OR REPLACE INTO " + s.storeName + " (key, value) VALUES (?, ?)", [t, n], function () {
                          u(c);
                        }, function (e, t) {
                          a(t);
                        });
                      }, function (n) {
                        if (n.code === n.QUOTA_ERR) {
                          if (o > 0) return void u(e.apply(i, [t, c, r, o - 1]));
                          a(n);
                        }
                      });
                    });
                  }).catch(a);
                });
                return a(c, r), c;
              }.apply(this, [e, t, n, 1]);
            },
            removeItem: function removeItem(e, t) {
              var n = this;
              e = s(e);
              var r = new u(function (t, r) {
                n.ready().then(function () {
                  var o = n._dbInfo;
                  o.db.transaction(function (n) {
                    Z(n, o, "DELETE FROM " + o.storeName + " WHERE key = ?", [e], function () {
                      t();
                    }, function (e, t) {
                      r(t);
                    });
                  });
                }).catch(r);
              });
              return a(r, t), r;
            },
            clear: function clear(e) {
              var t = this,
                  n = new u(function (e, n) {
                t.ready().then(function () {
                  var r = t._dbInfo;
                  r.db.transaction(function (t) {
                    Z(t, r, "DELETE FROM " + r.storeName, [], function () {
                      e();
                    }, function (e, t) {
                      n(t);
                    });
                  });
                }).catch(n);
              });
              return a(n, e), n;
            },
            length: function length(e) {
              var t = this,
                  n = new u(function (e, n) {
                t.ready().then(function () {
                  var r = t._dbInfo;
                  r.db.transaction(function (t) {
                    Z(t, r, "SELECT COUNT(key) as c FROM " + r.storeName, [], function (t, n) {
                      var r = n.rows.item(0).c;
                      e(r);
                    }, function (e, t) {
                      n(t);
                    });
                  });
                }).catch(n);
              });
              return a(n, e), n;
            },
            key: function key(e, t) {
              var n = this,
                  r = new u(function (t, r) {
                n.ready().then(function () {
                  var o = n._dbInfo;
                  o.db.transaction(function (n) {
                    Z(n, o, "SELECT key FROM " + o.storeName + " WHERE id = ? LIMIT 1", [e + 1], function (e, n) {
                      var r = n.rows.length ? n.rows.item(0).key : null;
                      t(r);
                    }, function (e, t) {
                      r(t);
                    });
                  });
                }).catch(r);
              });
              return a(r, t), r;
            },
            keys: function keys(e) {
              var t = this,
                  n = new u(function (e, n) {
                t.ready().then(function () {
                  var r = t._dbInfo;
                  r.db.transaction(function (t) {
                    Z(t, r, "SELECT key FROM " + r.storeName, [], function (t, n) {
                      for (var r = [], o = 0; o < n.rows.length; o++) {
                        r.push(n.rows.item(o).key);
                      }

                      e(r);
                    }, function (e, t) {
                      n(t);
                    });
                  });
                }).catch(n);
              });
              return a(n, e), n;
            },
            dropInstance: function dropInstance(e, t) {
              t = f.apply(this, arguments);
              var n = this.config();
              (e = "function" != typeof e && e || {}).name || (e.name = e.name || n.name, e.storeName = e.storeName || n.storeName);
              var r,
                  o = this;
              return a(r = e.name ? new u(function (t) {
                var r;
                r = e.name === n.name ? o._dbInfo.db : openDatabase(e.name, "", "", 0), e.storeName ? t({
                  db: r,
                  storeNames: [e.storeName]
                }) : t(function (e) {
                  return new u(function (t, n) {
                    e.transaction(function (r) {
                      r.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (n, r) {
                        for (var o = [], i = 0; i < r.rows.length; i++) {
                          o.push(r.rows.item(i).name);
                        }

                        t({
                          db: e,
                          storeNames: o
                        });
                      }, function (e, t) {
                        n(t);
                      });
                    }, function (e) {
                      n(e);
                    });
                  });
                }(r));
              }).then(function (e) {
                return new u(function (t, n) {
                  e.db.transaction(function (r) {
                    function o(e) {
                      return new u(function (t, n) {
                        r.executeSql("DROP TABLE IF EXISTS " + e, [], function () {
                          t();
                        }, function (e, t) {
                          n(t);
                        });
                      });
                    }

                    for (var i = [], a = 0, c = e.storeNames.length; a < c; a++) {
                      i.push(o(e.storeNames[a]));
                    }

                    u.all(i).then(function () {
                      t();
                    }).catch(function (e) {
                      n(e);
                    });
                  }, function (e) {
                    n(e);
                  });
                });
              }) : u.reject("Invalid arguments"), t), r;
            }
          };

          function ee(e, t) {
            var n = e.name + "/";
            return e.storeName !== t.storeName && (n += e.storeName + "/"), n;
          }

          function te() {
            return !function () {
              try {
                return localStorage.setItem("_localforage_support_test", !0), localStorage.removeItem("_localforage_support_test"), !1;
              } catch (e) {
                return !0;
              }
            }() || localStorage.length > 0;
          }

          var ne = {
            _driver: "localStorageWrapper",
            _initStorage: function _initStorage(e) {
              var t = {};
              if (e) for (var n in e) {
                t[n] = e[n];
              }
              return t.keyPrefix = ee(e, this._defaultConfig), te() ? (this._dbInfo = t, t.serializer = Q, u.resolve()) : u.reject();
            },
            _support: function () {
              try {
                return "undefined" != typeof localStorage && "setItem" in localStorage && !!localStorage.setItem;
              } catch (e) {
                return !1;
              }
            }(),
            iterate: function iterate(e, t) {
              var n = this,
                  r = n.ready().then(function () {
                for (var t = n._dbInfo, r = t.keyPrefix, o = r.length, i = localStorage.length, u = 1, a = 0; a < i; a++) {
                  var c = localStorage.key(a);

                  if (0 === c.indexOf(r)) {
                    var s = localStorage.getItem(c);
                    if (s && (s = t.serializer.deserialize(s)), void 0 !== (s = e(s, c.substring(o), u++))) return s;
                  }
                }
              });
              return a(r, t), r;
            },
            getItem: function getItem(e, t) {
              var n = this;
              e = s(e);
              var r = n.ready().then(function () {
                var t = n._dbInfo,
                    r = localStorage.getItem(t.keyPrefix + e);
                return r && (r = t.serializer.deserialize(r)), r;
              });
              return a(r, t), r;
            },
            setItem: function setItem(e, t, n) {
              var r = this;
              e = s(e);
              var o = r.ready().then(function () {
                void 0 === t && (t = null);
                var n = t;
                return new u(function (o, i) {
                  var u = r._dbInfo;
                  u.serializer.serialize(t, function (t, r) {
                    if (r) i(r);else try {
                      localStorage.setItem(u.keyPrefix + e, t), o(n);
                    } catch (e) {
                      "QuotaExceededError" !== e.name && "NS_ERROR_DOM_QUOTA_REACHED" !== e.name || i(e), i(e);
                    }
                  });
                });
              });
              return a(o, n), o;
            },
            removeItem: function removeItem(e, t) {
              var n = this;
              e = s(e);
              var r = n.ready().then(function () {
                var t = n._dbInfo;
                localStorage.removeItem(t.keyPrefix + e);
              });
              return a(r, t), r;
            },
            clear: function clear(e) {
              var t = this,
                  n = t.ready().then(function () {
                for (var e = t._dbInfo.keyPrefix, n = localStorage.length - 1; n >= 0; n--) {
                  var r = localStorage.key(n);
                  0 === r.indexOf(e) && localStorage.removeItem(r);
                }
              });
              return a(n, e), n;
            },
            length: function length(e) {
              var t = this.keys().then(function (e) {
                return e.length;
              });
              return a(t, e), t;
            },
            key: function key(e, t) {
              var n = this,
                  r = n.ready().then(function () {
                var t,
                    r = n._dbInfo;

                try {
                  t = localStorage.key(e);
                } catch (e) {
                  t = null;
                }

                return t && (t = t.substring(r.keyPrefix.length)), t;
              });
              return a(r, t), r;
            },
            keys: function keys(e) {
              var t = this,
                  n = t.ready().then(function () {
                for (var e = t._dbInfo, n = localStorage.length, r = [], o = 0; o < n; o++) {
                  var i = localStorage.key(o);
                  0 === i.indexOf(e.keyPrefix) && r.push(i.substring(e.keyPrefix.length));
                }

                return r;
              });
              return a(n, e), n;
            },
            dropInstance: function dropInstance(e, t) {
              if (t = f.apply(this, arguments), !(e = "function" != typeof e && e || {}).name) {
                var n = this.config();
                e.name = e.name || n.name, e.storeName = e.storeName || n.storeName;
              }

              var r,
                  o = this;
              return a(r = e.name ? new u(function (t) {
                e.storeName ? t(ee(e, o._defaultConfig)) : t(e.name + "/");
              }).then(function (e) {
                for (var t = localStorage.length - 1; t >= 0; t--) {
                  var n = localStorage.key(t);
                  0 === n.indexOf(e) && localStorage.removeItem(n);
                }
              }) : u.reject("Invalid arguments"), t), r;
            }
          },
              re = function re(e, t) {
            for (var n = e.length, r = 0; r < n;) {
              if ((o = e[r]) === (i = t) || "number" == typeof o && "number" == typeof i && isNaN(o) && isNaN(i)) return !0;
              r++;
            }

            var o, i;
            return !1;
          },
              oe = Array.isArray || function (e) {
            return "[object Array]" === Object.prototype.toString.call(e);
          },
              ie = {},
              ue = {},
              ae = {
            INDEXEDDB: N,
            WEBSQL: $,
            LOCALSTORAGE: ne
          },
              ce = [ae.INDEXEDDB._driver, ae.WEBSQL._driver, ae.LOCALSTORAGE._driver],
              se = ["dropInstance"],
              fe = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(se),
              le = {
            description: "",
            driver: ce.slice(),
            name: "localforage",
            size: 4980736,
            storeName: "keyvaluepairs",
            version: 1
          };

          function de(e, t) {
            e[t] = function () {
              var n = arguments;
              return e.ready().then(function () {
                return e[t].apply(e, n);
              });
            };
          }

          function he() {
            for (var e = 1; e < arguments.length; e++) {
              var t = arguments[e];
              if (t) for (var n in t) {
                t.hasOwnProperty(n) && (oe(t[n]) ? arguments[0][n] = t[n].slice() : arguments[0][n] = t[n]);
              }
            }

            return arguments[0];
          }

          var ve = function () {
            function e(t) {
              for (var n in function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e), ae) {
                if (ae.hasOwnProperty(n)) {
                  var r = ae[n],
                      o = r._driver;
                  this[n] = o, ie[o] || this.defineDriver(r);
                }
              }

              this._defaultConfig = he({}, le), this._config = he({}, this._defaultConfig, t), this._driverSet = null, this._initDriver = null, this._ready = !1, this._dbInfo = null, this._wrapLibraryMethodsWithReady(), this.setDriver(this._config.driver).catch(function () {});
            }

            return e.prototype.config = function (e) {
              if ("object" === (void 0 === e ? "undefined" : r(e))) {
                if (this._ready) return new Error("Can't call config() after localforage has been used.");

                for (var t in e) {
                  if ("storeName" === t && (e[t] = e[t].replace(/\W/g, "_")), "version" === t && "number" != typeof e[t]) return new Error("Database version must be a number.");
                  this._config[t] = e[t];
                }

                return !("driver" in e && e.driver) || this.setDriver(this._config.driver);
              }

              return "string" == typeof e ? this._config[e] : this._config;
            }, e.prototype.defineDriver = function (e, t, n) {
              var r = new u(function (t, n) {
                try {
                  var r = e._driver,
                      o = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                  if (!e._driver) return void n(o);

                  for (var i = fe.concat("_initStorage"), c = 0, s = i.length; c < s; c++) {
                    var f = i[c],
                        l = !re(se, f);
                    if ((l || e[f]) && "function" != typeof e[f]) return void n(o);
                  }

                  !function () {
                    for (var t = function t(e) {
                      return function () {
                        var t = new Error("Method " + e + " is not implemented by the current driver"),
                            n = u.reject(t);
                        return a(n, arguments[arguments.length - 1]), n;
                      };
                    }, n = 0, r = se.length; n < r; n++) {
                      var o = se[n];
                      e[o] || (e[o] = t(o));
                    }
                  }();

                  var d = function d(n) {
                    ie[r] && console.info("Redefining LocalForage driver: " + r), ie[r] = e, ue[r] = n, t();
                  };

                  "_support" in e ? e._support && "function" == typeof e._support ? e._support().then(d, n) : d(!!e._support) : d(!0);
                } catch (e) {
                  n(e);
                }
              });
              return c(r, t, n), r;
            }, e.prototype.driver = function () {
              return this._driver || null;
            }, e.prototype.getDriver = function (e, t, n) {
              var r = ie[e] ? u.resolve(ie[e]) : u.reject(new Error("Driver not found."));
              return c(r, t, n), r;
            }, e.prototype.getSerializer = function (e) {
              var t = u.resolve(Q);
              return c(t, e), t;
            }, e.prototype.ready = function (e) {
              var t = this,
                  n = t._driverSet.then(function () {
                return null === t._ready && (t._ready = t._initDriver()), t._ready;
              });

              return c(n, e, e), n;
            }, e.prototype.setDriver = function (e, t, n) {
              var r = this;
              oe(e) || (e = [e]);

              var o = this._getSupportedDrivers(e);

              function i() {
                r._config.driver = r.driver();
              }

              function a(e) {
                return r._extend(e), i(), r._ready = r._initStorage(r._config), r._ready;
              }

              var s = null !== this._driverSet ? this._driverSet.catch(function () {
                return u.resolve();
              }) : u.resolve();
              return this._driverSet = s.then(function () {
                var e = o[0];
                return r._dbInfo = null, r._ready = null, r.getDriver(e).then(function (e) {
                  r._driver = e._driver, i(), r._wrapLibraryMethodsWithReady(), r._initDriver = function (e) {
                    return function () {
                      var t = 0;
                      return function n() {
                        for (; t < e.length;) {
                          var o = e[t];
                          return t++, r._dbInfo = null, r._ready = null, r.getDriver(o).then(a).catch(n);
                        }

                        i();
                        var c = new Error("No available storage method found.");
                        return r._driverSet = u.reject(c), r._driverSet;
                      }();
                    };
                  }(o);
                });
              }).catch(function () {
                i();
                var e = new Error("No available storage method found.");
                return r._driverSet = u.reject(e), r._driverSet;
              }), c(this._driverSet, t, n), this._driverSet;
            }, e.prototype.supports = function (e) {
              return !!ue[e];
            }, e.prototype._extend = function (e) {
              he(this, e);
            }, e.prototype._getSupportedDrivers = function (e) {
              for (var t = [], n = 0, r = e.length; n < r; n++) {
                var o = e[n];
                this.supports(o) && t.push(o);
              }

              return t;
            }, e.prototype._wrapLibraryMethodsWithReady = function () {
              for (var e = 0, t = fe.length; e < t; e++) {
                de(this, fe[e]);
              }
            }, e.prototype.createInstance = function (t) {
              return new e(t);
            }, e;
          }(),
              pe = new ve();

          t.exports = pe;
        }, {
          3: 3
        }]
      }, {}, [4])(4);
    }).call(this, n(11));
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.trySilentLogin = t.iframeSilentLogin = t.inIframe = void 0;
    var r = n(1),
        o = n(4);
    t.inIframe = function () {
      try {
        return window.self !== window.top;
      } catch (e) {
        return !0;
      }
    }, t.iframeSilentLogin = function () {
      return (0, o.getTokenFromRedirect)().then(function (e) {
        var t = JSON.stringify({
          type: "SILENT_LOGIN",
          token: e
        });
        window.parent.postMessage(t, window.origin);
      }).catch(function (e) {
        var t = JSON.stringify({
          type: "SILENT_LOGIN",
          error: e.message
        });
        window.parent.postMessage(t, window.origin);
      });
    }, t.trySilentLogin = function (e) {
      return t = _regeneratorRuntime.mark(function t(n, r) {
        var a;
        return _regeneratorRuntime.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, (0, o.hasPreviousLogin)();

              case 2:
                if (t.sent) {
                  t.next = 5;
                  break;
                }

                return t.abrupt("return", Promise.resolve(null));

              case 5:
                return a = u()(n, r), window.addEventListener("message", a.handler, !1), i(e), t.abrupt("return", a.promise);

              case 9:
              case "end":
                return t.stop();
            }
          }
        }, t, void 0);
      }), n = function n() {
        var e = t.apply(this, arguments);
        return new Promise(function (t, n) {
          return function r(o, i) {
            try {
              var u = e[o](i),
                  a = u.value;
            } catch (e) {
              return void n(e);
            }

            if (!u.done) return Promise.resolve(a).then(function (e) {
              r("next", e);
            }, function (e) {
              r("throw", e);
            });
            t(a);
          }("next");
        });
      }, function (e, t) {
        return n.apply(this, arguments);
      };
      var t, n;
    };

    var i = function i(e) {
      var t = window.document,
          n = t.createElement("iframe");
      n.id = r.SILENT_LOGIN_IFRAME_ID, n.width = "0px", n.height = "0px", t.body.appendChild(n), n.src = (0, o.getLoginUrl)({
        config: e,
        skipPrompt: !0,
        state: "silent"
      });
    },
        u = function u() {
      return function () {
        var e = {},
            t = !1;
        return e.promise = new Promise(function (n, i) {
          e.handler = function (u) {
            if (!t && u.origin === window.origin) {
              var a,
                  c,
                  s = function (e) {
                var t = void 0;

                try {
                  t = JSON.parse(e);
                } catch (e) {
                  return;
                }

                return t;
              }(u.data);

              if (s && "SILENT_LOGIN" === s.type && s.token) window.removeEventListener("message", e.handler, !1), a = window.document, (c = a.getElementById(r.SILENT_LOGIN_IFRAME_ID)) && a.body.removeChild(c), s.error ? i(s.error) : n((0, o.makeToken)(s.token));
            }
          }, setTimeout(function () {
            t = !0, i(new Error("Silent Login Timed out"));
          }, 5e3);
        }), e;
      };
    };
  }, function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = n(0),
        i = n(2);

    function u(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "string";
      if ((void 0 === t ? "undefined" : r(t)) !== n) throw new Error("Error validating oauth configuration: " + e + " must be a(n) " + n);
    }

    t.default = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.config,
          n = e.authEvents,
          r = void 0 === n ? {} : n;
      return function (e) {
        u("authorization", e.authorization), u("client_id", e.client_id), u("redirect_uri", e.redirect_uri), u("response_type", e.response_type), u("scope", e.scope), e.store && (u(e.store.tokenName, "store.tokenName"), u(e.store.hydrateName, "store.hydrateName"));
      }(t), (0, i.initStore)(t.store), function (e) {
        var n = e.dispatch,
            i = e.getState;
        return function (e) {
          return function (u) {
            switch (u.type) {
              case o.loginUser.type:
                (0, o.innerLoginUser)(t, r)(n, i);
                break;

              case o.logoutUser.type:
                (0, o.innerLogoutUser)(r)(n, i);
                break;

              case o.initializeUserAuth.type:
                (0, o.innerInitializeUserAuth)(t, r)(n, i);
            }

            e(u);
          };
        };
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    var o = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this._events = {};
      }

      return r(e, [{
        key: "on",
        value: function value(e, t) {
          this._events[e] || (this._events[e] = []), this._events[e].push(t);
        }
      }, {
        key: "emit",
        value: function value(e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
            n[r - 1] = arguments[r];
          }

          this._events[e] && this._events[e].forEach(function (e) {
            e.apply(void 0, n);
          });
        }
      }]), e;
    }();

    t.default = o;
  }]);
});